<template>
  <div class="row mb-10">
    <div class="col-3">
      <img v-if="data.Id != 17" style="width: 100%;" src="@/assets/images/thongbao.jpg" alt="" />
      <img v-else style="width: 100%;" src="/taisan/201/1.jpg" alt="" />
    </div>
    <div class="col-9" style="margin: auto;">
      <a v-on:click="$router.push('/news/' + data.Id)" v-if="data.LoaiNoiDung == 0" target="_blank">
        - {{ data.TrichDan }}.
      </a>
      <a v-else-if="data.LoaiNoiDung == 1" :href="data.DuongDan" target="_blank"> - {{ data.TrichDan }}. </a>
      <a v-else-if="data.LoaiNoiDung == 2" :href="data.File" target="_blank"> - {{ data.TrichDan }}. </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsNotifyAuctionItem',
  props: ['data']
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/NewsNotifyAuctionItem.vue